module.exports = __webpack_public_path__ + "static/Prosource-Final-73c146a3f552d535d34c08e884299a31.mp4";